import { useTranslation } from "react-i18next";
import { LeftSocialMediaIconUI } from "../components/LeftSocialMediaIconUI";
import { headerHeight, OverviewLeftMenuList } from "../utils/constants";
import { RenderNavItem } from "../components/RenderNavItem";
import { scrollContainerStyle } from "../components/TableStructure";

export const TableUi = ({ title = "", header = "", list = [] }) => {
  const { t } = useTranslation();
  return (
    <>
      <section id="hero" className="hero hero2">
        <LeftSocialMediaIconUI />
        <div className="carousel-item active">
          <img src="assets/img/inner-bg2.png" className="img-fluid" alt="alt" />
        </div>
      </section>

      <section
        className="section inner-pad1"
        style={{ minHeight: `calc(100vh - ${headerHeight}px)` }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-3">
              <div className={`site-menu `}>
                <nav className="sidebar card py-2">
                  <ul className="nav flex-column" id="nav_accordion">
                    {OverviewLeftMenuList.map((item, index) => (
                      <RenderNavItem
                        key={item.id || index}
                        item={item}
                        index={index}
                        t={t}
                      />
                    ))}
                  </ul>
                </nav>
              </div>
            </div>

            <div className="col-lg-9">
              <div className="inner-title2">
                <h3 className="fontSizeClass">{title}</h3>
              </div>
              <div className="col-lg-12 about-head1">
                <div
                  className="dig-login1 dig-form"
                  style={{ padding: " 16px 0px" }}
                >
                  {header && (
                    <div className="inner-title3">
                      <h3
                        className="fontSizeClass mb-2"
                        style={{
                          display: "block",
                          color: "white",
                          fontWeight: "bold",
                          backgroundColor: "#302ba0",
                          padding: "10px 20px",
                        }}
                      >
                        {header}
                      </h3>
                    </div>
                  )}
                  <ol style={scrollContainerStyle}>
                    {list.map((item, index) => (
                      <li key={index} className="font-weight-bold">{item}</li>
                    ))}
                  </ol>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

const Power = () => (
  <TableUi
    title="Powers"
    header="Some of the Powers of the KMC are :"
    list={[
      "Making subordinate legislation, i.e. making of regulations",
      "Levying of taxes, fees and charges etc",
      "Sanctioning expenditures",
      "Relating to budget approvals",
      "Providing civic amenities",
      "Regulatory and Statutory powers relating to planning and development",
      "Community health, registration of births and deaths, issue of municipal licenses etc",
      "Powers relating to establishments",
    ]}
  />
);

export default Power;
